import { type RoomRowData } from './types';

export function roomRowHasClasses(row: RoomRowData): boolean {
  return row.lanes.some((lane) => lane.length > 0);
}

export function filterRoomRowsByEmptyRooms(
  rows: Array<RoomRowData>,
  showEmptyRooms: boolean,
): Array<RoomRowData> {
  if (showEmptyRooms) return rows;
  return rows.filter(roomRowHasClasses);
}
